<script setup lang="ts">
const props = defineProps<{
  error?: {
    statusCode?: number
    statusMessage?: string
    message?: string
  }
}>()

const handleError = () => clearError({ redirect: '/' })

const statusCode = computed(() => props.error?.statusCode || 404)
const statusMessage = computed(() => props.error?.statusMessage || 'Page not found')
const message = computed(() => props.error?.message || 'The page you are looking for does not exist.')
</script>

<template>
  <div class="flex min-h-screen items-center justify-center bg-[#131318]">
    <div class="text-center">
      <h1 class="text-6xl font-bold text-white mb-4">
        {{ statusCode }}
      </h1>
      <h2 class="text-2xl font-semibold text-[#E7E7EC] mb-2">
        {{ statusMessage }}
      </h2>
      <p class="text-[#8888A1] mb-6">
        {{ message }}
      </p>
      <UButton
        color="primary"
        @click="handleError"
      >
        Go Home
      </UButton>
    </div>
  </div>
</template>
